export default "__VITE_ASSET__CuamcX4G__"